export default __webpack_public_path__ + "static/media/chevero-down.09e86c47.svg";